import CodeConfirmation from './CodeConfirmation';

export default CodeConfirmation;
